export const actions = {
  async nuxtServerInit({ dispatch }) {
    await Promise.all([
      dispatch('promo/initPromo'),
      dispatch('settings/initSettings'),
      dispatch('menu/initMenu'),
    ])
  },
}
